import axios, {
  AxiosInstance,
  AxiosRequestConfig,
  InternalAxiosRequestConfig,
} from "axios";
import Cookies from "js-cookie";

const X_AUTH_TOKEN = "X-AUTH-TOKEN";

export interface HttpClient extends AxiosInstance {
  get<T = any>(url: string, config?: AxiosRequestConfig): Promise<T>;
  post<T = any>(
    url: string,
    data?: unknown,
    config?: AxiosRequestConfig
  ): Promise<T>;
}

const axiosInstance = axios.create();
export const http: HttpClient = axiosInstance;

http.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  return configManager(config);
});
http.interceptors.response.use(
  (res) => res.data,
  (err) => {
    if (
      err.response.data?.error === "Unauthorized" &&
      Cookies.get(X_AUTH_TOKEN)
    ) {
      if (window.confirm("세션이 만료되었습니다. 다시 로그인해주세요.")) {
        Cookies.remove(X_AUTH_TOKEN);
        Cookies.remove(X_AUTH_TOKEN, { domain: ".aibizon.com" });
        window.location.href = "/login";
      } else return;
    }
    return Promise.reject(err);
  }
);

const rawAxiosInstance = axios.create();
export const rawHttp: HttpClient = rawAxiosInstance;

rawHttp.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  return configManager(config);
});

const configManager = (config: InternalAxiosRequestConfig) => {
  // test with dev server
  const prefix = "/api/v2";
  config.url = prefix + config.url;

  const authToken = Cookies.get(X_AUTH_TOKEN);
  if (authToken) {
    config.headers["X-AUTH-TOKEN"] = authToken;
    config.withCredentials = true;
  } else {
    config.withCredentials = false;
  }
  return config;
};
